export default {
      id: "icon-llkw-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-llkw",
      toString: function () {
        return this.url;
      }
    }